import { FC, useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Form } from "capitalrx-components-2.0/lib/forms";
import { Grid, Shelf, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";

import { Phonebox } from "../PhoneboxInput";
import { ThemedSubmitButton } from "../themed";
import { isValidPhoneNumber } from "react-phone-number-input";

export interface SetupSMSFormProps {
  readonly onSubmit: (phoneNumber: string) => void | Promise<void>;
}

export const SetupSMSForm: FC<SetupSMSFormProps> = ({ onSubmit }) => {
  const { t: translate } = useTranslation();
  const form = useForm({
    defaultValues: {
      phoneNumber: "",
    },
  });

  useEffect(() => {
    form.setFocus("phoneNumber");
  }, []);

  const phoneValidator = useCallback((value: string) => {
    if(!isValidPhoneNumber(value)) {
      return translate("MULTIFACTOR_AUTHENTICATION.setupSmsForm.enterValidPhoneNumber");
    }
    return undefined;
  }, []);

  const { responsiveWidth } = useResponsive({
    responsiveWidth: {
      mobile: "100%",
      desktop: "45%",
    },
  });

  const handleSubmit = useCallback(async (formData: { readonly phoneNumber: string }) => {
    onSubmit(formData.phoneNumber);
  }, []);

  return (
    <Form onSubmit={handleSubmit} form={form}>
      <Stack>
        <Shelf>
          <Shelf.Spacer />
          <Phonebox.Field
            style={{ width: responsiveWidth }}
            label={translate("MULTIFACTOR_AUTHENTICATION.setupSmsForm.mobileNumber")}
            instructions={translate("MULTIFACTOR_AUTHENTICATION.setupSmsForm.agreeToReceiveTextMessages")}
            useCountryCode
            required
            validator={phoneValidator}
            name="phoneNumber"
          />
          <Shelf.Spacer />
        </Shelf>
        <Grid>
          <ThemedSubmitButton>{translate("MULTIFACTOR_AUTHENTICATION.setupSmsForm.next")}</ThemedSubmitButton>
        </Grid>
      </Stack>
    </Form>
  );
};
